import { green } from '@ant-design/colors'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert, Card, ConfigProvider, Space } from 'antd'
import theme from 'antd/lib/theme'
import { ReactNode, useEffect, useState } from 'react'
import ThemableButton from '../Items/ThemableButton'
import { hasCompletedHandoff, recordCompletedHandoff } from './appHandoffModel'
import './SignIn.css'

export type Props = {
  token: string
  appUrl: string | null
  invalidLinkMessage: string
  prompt: ReactNode
  alreadyOpenedPrompt: ReactNode
  buttonLabel: string
  icon: IconDefinition
}

const AppHandoff = ({ token, appUrl, invalidLinkMessage, prompt, alreadyOpenedPrompt, buttonLabel, icon }: Props) => {
  const [alreadyOpened] = useState(() => hasCompletedHandoff(token))

  useEffect(() => {
    if (!appUrl || alreadyOpened) {
      return
    }
    recordCompletedHandoff(token)
    window.location.href = appUrl
  }, [appUrl, token, alreadyOpened])

  return <div className="sign-in-container">
    <Space direction="vertical" size="middle" style={{ maxWidth: 400, padding: 8 }}>
      <img src="/images/synkedup-dark.png" alt="SynkedUP" style={{ maxWidth: '100%' }} />
      {!appUrl && <Alert message={invalidLinkMessage} type="error" showIcon />}
      {appUrl && <>
        <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
          <Card style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            {alreadyOpened ? alreadyOpenedPrompt : prompt}
          </Card>
        </ConfigProvider>
        <ThemableButton
          type="primary"
          colorPrimary={green.primary}
          icon={<FontAwesomeIcon icon={icon} />}
          href={appUrl}
        >
          {buttonLabel}
        </ThemableButton>
      </>}
    </Space>
  </div>
}

export default AppHandoff
